<template>
  <Fragment>
    <font-awesome-icon :icon="['fab', icon]" :color="icon_color" /> <a :href="url"> {{title}}</a>
  </Fragment>
</template>

<script>
  import { Fragment } from 'vue-fragment'

  export default {
    name: 'SocialLink',
    props: {
      icon: String,
      icon_color: String,
      url: String,
      title: String
    },
    components: {
      Fragment
    }
  }
</script>
